<template>
<!-- 写入意见 -->
  <div class='question-opinion'>
    <single-title :num='num' :title='otitle' :ofrom='ohtml'></single-title>
    <div class="opinputWrapper">
      <el-input
          ref='opRef'
          class='opinionInput'
          type="textarea"
          :rows="5"
          placeholder="字数限制100以内"
          maxlength="100"
          show-word-limit
          @focus='ofoucs'
          @blur='ablur'
          v-model="inputOpinion">
      </el-input>
    </div>
  </div>
</template>

<script>
import SingleTitle from '@/components/SingleTitle/SingleTitle'
export default {
  name: 'QuestionOpinion',
  props: ['num', 'otitle'],
  data() {
    return {
      inputOpinion: '',
      ohtml: 'yeshtml'
    }
  },
  watch: {
    inputOpinion(newVal, oldVal) {
      this.$emit('ovalchange', newVal);
    }
  },
  computed: {
  },
  methods: {
    ofoucs() {
      console.log('akkk focus')
      this.$emit('ofocus')
    },
    ablur() {
      this.$emit('oblur')
    },
    blur() {
      this.$refs.opRef.blur();
    }
  },
  components: {
    SingleTitle
  },
  mounted() {
    // console.log('num===', this.num);
    // console.log('otitle===', this.otitle);
  }
}
</script>

<style lang='scss' scoped>
@import '~@/common/scss/const.scss';
@import '~@/common/scss/mixin.scss';

.question-opinion {
  @include box-sizing(content-box);
  background: $color-background-w;
  border-radius: 4px;
  padding: pxToRem(18) pxToRem(16);
  margin-top: pxToRem(15);
  font-size: 14px;
  line-height: 20px;
  .opinputWrapper {
    margin-top: pxToRem(15);
    .opinionInput {
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/QuestionOpinion/QuestionOpinion.vue